import React, { useState, useRef, useEffect } from 'react'
import style from "./style.module.sass"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { Alert } from "@material-ui/lab"
import { Button, Collapse, Modal } from "@material-ui/core"
import { convertFromErrorObject, convertLanguagesToShort } from '../../../../../utils'
import config from '../../../../../config'
import TLServiceComponent from '../../../../../contexts/TLServiceComponent'
import TermsModalTabs from '../../../ModalBaseElements/TermModalTabs'
import NearTermTabs from '../../../ModalBaseElements/NearTermTabs'


export default function TextTypeAddEditModal({
  open, currentTextType,
  setOpen, callEndPoint
}) {
  const tlService = React.useContext(TLServiceComponent)
  const token = useSelector(state => state.userData.token)
  const { t, i18n: { language: i18nLanguage } } = useTranslation()
  const [lang, setLang] = useState(i18nLanguage)
  const [name, setName] = useState('')
  const [alertMsg, setAlertMsg] = useState()
  const [description, setDescription] = useState('')
  const languageIs = useRef()

  const [termLanguage, setTermLanguage] = useState()
  const backendLanguages = useSelector(state => state.userData.user?.backend_languages || {})

  useEffect(() => {
    let resultLanguage = Object.keys(backendLanguages).filter(lang =>
      convertLanguagesToShort(lang) === i18nLanguage
    )
    languageIs.current = resultLanguage
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18nLanguage])

  useEffect(() => {
    if (!!currentTextType) {
      setTermLanguage(convertLanguagesToShort(currentTextType.locale_name))
      setDescription(currentTextType.description)
      setName(currentTextType.name)
    } else {
      setName("")
      setDescription("")
      setTermLanguage(i18nLanguage)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTextType, open])


  const editBenchmark = async () => {
    if (!!currentTextType) {
      try {
        await tlService.updateBenchmark(token, currentTextType.id, JSON.stringify(name), JSON.stringify(description), JSON.stringify(currentTextType.calcelements_setting), JSON.stringify(currentTextType.return_values), JSON.stringify(currentTextType.settings))
        setOpen(false)
      } catch (err) {
        console.log(err)
        setAlertMsg(convertFromErrorObject(t, err))
        setTimeout(() => {
          setAlertMsg('')
        }, config.timeOutDuration)
      }
      callEndPoint()
    } 
  }

  const defaultState = () => {
    setName("")
    setDescription("")
    setOpen(false)
  }
  return (
    <Modal open={open} onClose={() => defaultState()}>
      <div style={{ position: "absolute", marginLeft: "10%", marginTop: "1%" }} >
        <div className={style.termModal}>
          {!!currentTextType ?
            <h2>{t('edit-term-list')} </h2> :
            <h2>{t('add-term-list')} </h2>
          }
          <div className={`d-flex`}>
            <div className={`col-6`}>
              <TermsModalTabs
                setDescription={setDescription} description={description}
                name={name} setName={setName} setLang={setLang} lang={lang} />
            </div>
            <div className={`col-6`}>
              <h3 className={`${style.partTitle}`}>{t("language")}</h3>
              <NearTermTabs
                setTermLanguage={setTermLanguage}
                termLanguage={termLanguage}
                currentTerm={currentTextType}
                texttype={true}
              />
            </div>
          </div>
          <div className={style.error}>
            <Collapse in={!!alertMsg}>
              <Alert
                className={`m-0`}
                severity='error'>
                <h6 className={`m-0`}>
                  {alertMsg}
                </h6>
              </Alert>
            </Collapse>
          </div>
          <div className={`d-flex justify-content-end mt-4`}>
            <Button variant='contained' onClick={() =>
              defaultState()}>
              {t('close')}
            </Button>
            <Button color='primary' variant='contained' className={`ml-2`} onClick={() => editBenchmark()}>
              {t('save')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
